'use client';

import { useState } from 'react';

import axios from 'axios';

import VideoActions from './components/VideoActions';
import VideoDescription from './components/VideoDescription';
import VideoInfo from './components/VideoInfo';
import VideoPlayer from './components/VideoPlayer';
import VideoSummary from './components/VideoSummary';
import VideoTranscript from './components/VideoTranscript';

type YouTubeVideoProps = {
  docId?: string;
  videoUrl: string;
  title: string;
  description: string;
  transcript?: string;
  summary?: string;
  channelName: string;
  channelAvatar: string;
  uploadDate?: string;
  subscribers?: string;
  likes?: string;
  views?: string;
  hideActions?: boolean;
  hideSubscribe?: boolean;
  isEditable?: boolean;
};

const defaultProps: YouTubeVideoProps = {
  videoUrl: '/placeholder-video.mp4',
  title: 'Awesome Video Title',
  uploadDate: 'Jan 1, 2025',
  channelName: 'Cool Channel',
  channelAvatar: '/images/placeholder.svg?height=48&width=48',
  hideActions: false,
  hideSubscribe: false,
  isEditable: false,
};

export default function YouTubeVideo(props: YouTubeVideoProps = defaultProps) {
  const [videoData, setVideoData] = useState(props);
  const [currentView, setCurrentView] = useState<
    'description' | 'transcript' | 'summary' | 'download'
  >('description');

  const handleDataChange = (key: string, value: string) => {
    if (!videoData.isEditable) return;
    setVideoData((prev) => ({ ...prev, [key]: value }));
  };

  const downloadVideo = async () => {
    const video = await axios.get(`/api/extract/video?url=${props.videoUrl}`);
    console.log(video);
  };

  const renderContent = () => {
    switch (currentView) {
      case 'transcript':
        return (
          <VideoTranscript
            docId={props.docId}
            transcript={props.transcript}
            videoUrl={props.videoUrl}
            onDataChange={handleDataChange}
          />
        );
      case 'summary':
        return (
          <VideoSummary
            docId={props.docId}
            summary={props.summary}
            videoUrl={props.videoUrl}
            onDataChange={handleDataChange}
          />
        );
      default:
        return (
          <VideoDescription
            description={videoData.description}
            onDataChange={handleDataChange}
            isEditable={videoData.isEditable}
          />
        );
    }
  };

  return (
    <div className="bg-background text-foreground mx-4 w-full max-w-6xl overflow-hidden rounded-xl border shadow-sm">
      <VideoPlayer
        videoUrl={videoData.videoUrl}
        onVideoChange={(newUrl) => handleDataChange('videoUrl', newUrl)}
      />
      <VideoInfo
        title={videoData.title}
        views={videoData.views}
        uploadDate={videoData.uploadDate}
        channelName={videoData.channelName}
        channelAvatar={videoData.channelAvatar}
        subscribers={videoData.subscribers}
        onDataChange={handleDataChange}
        hideSubscribe={videoData.hideSubscribe}
        isEditable={videoData.isEditable}
      />
      {!videoData.hideActions && (
        <VideoActions
          likes={videoData.likes}
          onDataChange={handleDataChange}
          isEditable={videoData.isEditable}
          setCurrentView={setCurrentView}
          currentView={currentView}
          downloadVideo={downloadVideo}
        />
      )}
      {renderContent()}
    </div>
  );
}
